import React, { useContext, useEffect, useReducer, useMemo } from 'react';
import { Box, TextField, IconButton, Tooltip } from '@mui/material';
import ColorButton from '../Buttons/ColorButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Table, { TableHook } from '../Table';
import { lockedReducer } from '../Utils/reducers';
import { api } from '../../services/api';
import { externalComponent } from '../AppRoutes';
import EditNovaTabela from './editNovaTabela';
import EditProdutos from './editProdutos';
import { formatDate } from '../Utils/functions';
import EditIcon from '@mui/icons-material/Edit';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ConfirmationDialog from '../Utils/ConfirmationDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import CopyTableModal from './copyTableModal';


const getcolumns = (setState) => {
    const columns = []
    columns.push({
        field: 'produtos', headerName: 'Produtos', width: 80,
        renderCell: (props) => {
            return (
                <Box>
                    <Tooltip title='Visualizar produtos'><IconButton onClick={() => { setState({ productRow: props.row }) }}><TableRowsIcon /></IconButton></Tooltip>
                </Box>
            )
        }
    })
    columns.push({ field: 'nome', headerName: 'Nome', width: 200 })
    columns.push({ field: 'filiais', headerName: 'Grupo filial', flex: 1 })
    columns.push({ field: 'data_fim', headerName: 'Data fim', width: 100, renderCell: ({ value }) => (<Box>{formatDate(value)}</Box>) })
    columns.push({ field: 'desconto_valor_avista', headerName: 'Desconto à vista', width: 100, renderCell: ({ value }) => (<Box>{value}%</Box>) })
    columns.push({ field: 'ativo', headerName: 'Status', width: 100, renderCell: ({ value }) => (<Box>{statusConvert(value)}</Box>) })
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 150,
        renderCell: (props) => {
            return (
                <Box>
                    <Tooltip title='Editar tabela'><IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton></Tooltip>
                    <Tooltip title='Criar cópia da tabela'><IconButton onClick={() => { setState({ copyRow: props.row }) }}><ContentCopyIcon /></IconButton></Tooltip>
                    {
                        props.row.produtos === 0 ?
                            (
                                <Tooltip title='Deleta tabela'><IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton></Tooltip>
                            )
                            :
                            null
                    }
                </Box>
            )
        }
    })

    return columns
}

const statusConvert = (value) => {
    const statusMap = {
        true: 'Ativo',
        false: 'Desativado'
    };

    return statusMap[value] || 'Desativado';
};

const selectStatus = [{ id: '0', type: 'Ativo' }, { id: '1', type: 'Desativado' }]

const getTables = async (setLoader, setState) => {
    setLoader(true)
    const res = await api.get(`/tabelas/`)
    if (res.status === 200) {
        const filtered = res.data.filter(each => each.ativo === true)
        setState({ rows: filtered, rowsReset: res.data })
    }
    setLoader(false)
}

const deleteTable = async (setLoader, setState, getTables, id) => {
    setLoader(true)
    const res = await api.post(`/tabelas/deleta/${id}`)
    if (res.status === 200) {
        await getTables(setLoader, setState)
        setState({ deleteRow: null })
    }
    setLoader(false)
}

const filterRows = (nome, status, setState, state) => {
    const ativo = status === '0' ? true : false;
    const filtered = state.rowsReset.filter(each => each.nome.toLowerCase().includes(nome.toLowerCase())).filter(
        each => each.ativo === ativo
    )
    setState({ rows: filtered })
}


const GerenciarTabela = () => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        rowsReset: [],
        editRow: null,
        hideRow: null,
        productRow: null,
        copyRow: null,
        deleteRow: null,
        nameFilter: '',
        dtInicioFirst: '',
        dtInicioSecond: '',
        dtFimFirst: '',
        dtFimSecond: '',
        statusSelected: '0',
    })

    const { setLoader } = useContext(externalComponent)

    const [table] = TableHook()

    useEffect(() => {
        getTables(setLoader, setState)
    }, [])

    return (
        <>
            <Box className='nfsentrada-mainframe'>

                <Box sx={{ flex: .15 }} className='nfsentrada-filters'>

                    <Box className='filter-items'>
                        <TextField
                            id="nameFilter"
                            type="text"
                            label="Nome"
                            size='small'
                            value={state.nameFilter}
                            onChange={(e) => { setState({ 'nameFilter': e.target.value }) }}
                            fullWidth={false}
                            sx={{ width: '17rem' }}
                        />

                        <FormControl size="small">
                            <InputLabel id="demo-simple-select-label">Status</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Status"
                                value={state.statusSelected}
                                onChange={(e) => setState({ statusSelected: e.target.value })}
                                sx={{ width: '8rem' }}
                            >

                                {
                                    Object.entries(selectStatus).map(([key, value]) => (
                                        <MenuItem key={key} value={value.id}>{value.type}</MenuItem>
                                    ))
                                }

                            </Select>
                        </FormControl>

                    </Box>

                    <Box className='filter-buttons'>

                        <ColorButton onClick={() => filterRows(state.nameFilter, state.statusSelected, setState, state)}> Localizar </ColorButton>
                        <ColorButton onClick={() => setState({ rows: state.rowsReset })}> Limpar filtros </ColorButton>

                    </Box>

                </Box>


                <Box sx={{ flex: .85 }}>
                    <Table
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={useMemo(() => getcolumns(setState), [state.rows, state.edit])}
                        pagination={false}
                        toolbar
                        slots={{
                            addComponent: () => setState({ editRow: {} }),
                            columnComponent: true
                        }}
                        rowHeight={30}
                        innerRef={table}
                    />
                </Box>

            </Box>

            {
                state.editRow &&
                <EditNovaTabela
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={() => getTables(setLoader, setState)}
                />
            }

            {
                state.productRow &&
                <EditProdutos
                    data={state.productRow}
                    handleClose={() => setState({ productRow: null })}
                    reloadData={() => getTables(setLoader, setState)}
                />

            }

            {
                state.copyRow &&
                <CopyTableModal
                    data={state.copyRow}
                    handleClose={() => setState({ copyRow: null })}
                    reloadData={() => getTables(setLoader, setState)}
                />

            }

            {
                state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir a tabela ${state.deleteRow.nome} ?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => deleteTable(setLoader, setState, getTables, state.deleteRow.id)}
                />

            }


        </>
    )
}

export default GerenciarTabela;